// 交易看板標題組件
export default {
  // 標題
  tradingDashboard: "交易看板",
  updated: "更新",

  // 提示信息
  delayTooltip:
    "地址首次加入交易看板時，數據最多會有1個小時的延遲，請耐心等待。",

  // 占位符和標籤
  selectCurrency: "選擇幣種",
  allBlockchains: "全部",
};
